import { HOW_IT_WORKS } from "../content";
import "./HowItWorks.css";

/** Cómo funciona (#como-funciona): de la demo al primer torneo en 4 pasos.
 * En escritorio van en fila unidos por una línea punteada; en celular, en
 * lista vertical. */
export function HowItWorks() {
  return (
    <section id="como-funciona" className="t123-section t123-steps" aria-labelledby="t123-steps-title">
      <div className="t123-shell">
        <div className="t123-heading-center">
          <h2 id="t123-steps-title" className="t123-h2">
            De la demo a tu primer torneo, en 4 pasos
          </h2>
        </div>
        <ol className="t123-steps__list">
          {HOW_IT_WORKS.map((step, index) => (
            <li key={step.title} className="t123-steps__item">
              <span className="t123-steps__num" aria-hidden="true">
                {index + 1}
              </span>
              <div className="t123-steps__body">
                <h3>{step.title}</h3>
                <p>{step.copy}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
